class FreeShippingMeter extends HTMLElement {
    constructor() {
        super();
    }

    static classLabel1 = 'progress-30';
    static classLabel2 = 'progress-60';
    static classLabel3 = 'progress-100';

    connectedCallback() {
        this.freeShippingEligible = 0;
        this.progressBar = this.querySelector('[data-shipping-progress]');
        this.messageElement = this.querySelector('[data-shipping-message]');
        this.textEnabled = this.progressBar?.dataset.textEnabled === 'true';
        this.progressMeter = this.querySelector('[data-free-shipping-progress-meter]');

        // Ella grabs the target threshold from a data attribute (set via Theme Settings)
        // Multiply by 100 because Shopify cart.total_price is returned in cents.
        const datasetAmount = this.dataset.amount || 100; 
        this.targetAmount = parseFloat(datasetAmount) * 100;

        this.addEventListener('change', this.onCartChange.bind(this));

        this.initialize();
    }

    initialize() {
        // Fetching standard Shopify cart data
        fetch(window.Shopify?.routes?.root + 'cart.js' || '/cart.js')
            .then(response => response.json())
            .then(cart => {
                this.cart = cart;
                this.calculateProgress(cart);
            })
            .catch(error => console.error('Error fetching cart:', error));
    }

    onCartChange(e) {
        this.initialize();
    }

    calculateProgress(cart) {
        const cartTotal = cart.total_price || 0;
        
        // Prevent division by zero if target is 0
        if (this.targetAmount <= 0) return;

        let freeShipBar = (cartTotal / this.targetAmount) * 100;

        if (freeShipBar >= 100) {
            freeShipBar = 100;
        }

        const text = this.getText(cartTotal, this.targetAmount);
        const classLabel = this.getClassLabel(freeShipBar);

        this.setProgressWidthAndText(freeShipBar, text, classLabel);
    }

    getText(cartTotal, targetAmount) {
        let text;

        if (cartTotal === 0) {
            this.progressBar.classList.add('progress-hidden');
            text =
                '<span>Spend </span>' +
                '<strong class="shipping-price">' + this.formatMoney(targetAmount) + '</strong>' +
                '<span> more to unlock </span>' +
                '<span class="text">free shipping</span>';
        } else if (cartTotal >= targetAmount) {
            this.progressBar.classList.remove('progress-hidden');
            this.freeShippingEligible = 1;
            text =
                '<span>You have unlocked </span>' +
                '<span class="text">free shipping</span>' +
                '<span>!</span>';
        } else {
            this.progressBar.classList.remove('progress-hidden');
            const remainingAmount = targetAmount - cartTotal;
            text =
                '<span>Add </span>' +
                '<strong class="shipping-price">' + this.formatMoney(remainingAmount) + '</strong>' +
                '<span>  more to unlock </span>' +
                '<span class="text">free standard shipping</span>';
        }

        return text;
    }

    // Helper to format cents into dollars for the frontend
    formatMoney(cents) {
        // If Ella's global Shopify format money exists, use it
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
            const format = window.theme_money_format || window.money_format || '${{amount}}';
            return Shopify.formatMoney(cents, format);
        }
        // Fallback standard format
        return '$' + (cents / 100).toFixed(2);
    }

    getClassLabel(freeShipBar) {
        let classLabel;

        if (freeShipBar === 0) {
            classLabel = 'none';
        } else if (freeShipBar <= 30) {
            classLabel = FreeShippingMeter.classLabel1;
        } else if (freeShipBar <= 60) {
            classLabel = FreeShippingMeter.classLabel2;
        } else if (freeShipBar < 100) {
            classLabel = FreeShippingMeter.classLabel3;
        } else {
            classLabel = 'progress-free';
        }

        return classLabel;
    }

    resetProgressClass(classLabel) {
        this.progressBar.classList.remove('progress-30', 'progress-60', 'progress-100', 'progress-free');
        this.progressBar.classList.add(classLabel);
    }

    setProgressWidthAndText(freeShipBar, text, classLabel) {
        setTimeout(() => {
            this.resetProgressClass(classLabel);

            if (this.progressMeter) {
                this.progressMeter.style.width = `${freeShipBar}%`;

                if (this.textEnabled) {
                    const percentText = this.progressMeter.querySelector('.text');
                    if (percentText) {
                        // Using Math.floor to match Ella's clean UI (e.g., 85% instead of 85.00%)
                        percentText.innerHTML = `${Math.floor(freeShipBar)}%`;
                    }
                }
            }

            if (this.messageElement) {
                this.messageElement.innerHTML = text;
            }
        }, 400);
    }
}

window.addEventListener('load', () => {
    if (!customElements.get('free-shipping-component')) {
        customElements.define('free-shipping-component', FreeShippingMeter);
    }
});